export default {
    path: '/tools',
    name: 'tools.index',
    component: () => import('@/views/Index.vue'),
    meta: {
        auth: true,
        label: 'Tools',
        icon: 'fal fa-external-link-square fa-fw',
        location: 'sidebar-top',
        permission: 'manage-passwords',
    },
    children: [
        {
            path: 'system-status',
            name: 'tools.system-status.index',
            component: () => import('@/modules/tools/system/Index.vue'),
            meta: {
                auth: true,
                label: 'System Status',
                icon: 'fal fa-external-link-square fa-fw',
                permission: 'system:component:view-any',
                location: 'sidebar',
            },
            children: [
                {
                    path: 'components',
                    name: 'tools.system-status.components.index',
                    component: () => import('@/modules/tools/system/components/Index.vue'),
                    meta: {
                        auth: true,
                        label: 'Components',
                        icon: 'fal fa-gears fa-fw',
                        permission: 'system:component:view-any',
                        location: 'sidebar',
                    },
                    children: [
                        {
                            path: 'create',
                            name: 'tools.system-status.components.create',
                            component: () => import('@/modules/tools/system/components/Index.vue'),
                            meta: {
                                auth: true,
                                label: 'Create',
                                icon: 'fal fa-gears fa-fw',
                                permission: 'system:component:create',
                            },
                        },
                        {
                            path: ':componentId/edit',
                            name: 'tools.system-status.components.edit',
                            component: () => import('@/modules/tools/system/components/Index.vue'),
                            meta: {
                                auth: true,
                                label: 'Edit',
                                icon: 'fal fa-house-fire fa-fw',
                                permission: 'system:component:update',
                            },
                        },
                    ],
                },
                // {
                //     path: "incidents",
                //     name: "tools.system-status.incidents.index",
                //     component: () => import("@/modules/tools/system/incidents/Index.vue"),
                //     meta: {
                //         auth: true,
                //         label: "Incidents",
                //         icon: "fal fa-house-fire fa-fw",
                //         permission: "system:incident:view-any",
                //     },
                // },
            ],
        },
    ],
}
